import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Tabs, Tab, TabsProps } from '@material-ui/core';

import { grayBlue, primaryGreen, borderColor } from 'src/data/colors';
import TabsContainer from './TabsContainer';
import TabPanel from './TabPanel';

export interface StyledTabProps {
  label: string;
}

const TabHeader = withStyles(() =>
  createStyles({
    root: {
      margin: '0 auto',
      borderBottom: `1px solid ${borderColor}`,
      color: `${grayBlue} !important`,
      maxWidth: '1284px',
      '& .Mui-selected': {
        color: `${primaryGreen} !important`,
      },

      '& .MuiTab-root': {
        fontSize: 16,
        fontWeight: 500,
        '&:hover': {
          color: primaryGreen,
        },
      },
    },
    indicator: {
      backgroundColor: primaryGreen,
    },
    flexContainer: {
      flexWrap: 'nowrap',
      display: 'flex',
    },
    scroller: {
      overflow: 'auto',
      overflowY: 'hidden',
      scrollbarWidth: 'auto',
      '&::-webkit-scrollbar': {
        height: '6px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: borderColor,
        borderRadius: '3px',
      },
    },
  })
)((props: TabsProps) => <Tabs {...props} scrollButtons="auto" variant="scrollable" />);

const TabButton = withStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular as number,
      marginRight: '16px',
      '&:hover': {
        color: primaryGreen,
        opacity: 1,
      },
      '&$selected': {
        color: primaryGreen,
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: primaryGreen,
      },
    },
  })
)((props: StyledTabProps) => <Tab disableRipple {...props} />);

export { TabHeader, TabButton, TabsContainer, TabPanel };
